module.exports = __webpack_public_path__ + "img/179.05aef6af.jpg";